import { isString } from '@tunasong/models'
import type { SearchSummary } from '@tunasong/models'
import type { Entity, Persisted } from '@tunasong/schemas'
import {Dialog, DialogTitle, useNavigateToEntity, Tab, Tabs, DialogContent} from '@tunasong/ui-lib'
import { useCallback, useState } from 'react'
import styles from './search-dialog.hook.module.css'
import { FullSearch } from './full-search.js'
import { allQueries } from './queries/index.js'
import { SearchList } from './search-list.js'

export const useSearchDialog = (currentEntity?: Persisted<Entity>) => {
  const [open, setOpen] = useState(false)

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])
  const navigateToEntity = useNavigateToEntity()

  const handleOpen = useCallback(
    (result: SearchSummary | Persisted<Entity> | string | null) => {
      if (!result || isString(result)) {
        return
      }
      navigateToEntity(result, { layout: 'default' })
      setOpen(false)
    },
    [navigateToEntity]
  )
  const [tab, setTab] = useState('Search')

  const dialog = open ? (
    <Dialog
      open={open}
      className={styles.dialog}
      onClose={handleClose}
      maxWidth={'sm'}
      fullWidth={true}
    >
      <DialogTitle onClose={handleClose}>
        <Tabs value={tab} onChange={(_ev, val) => setTab(val as string)}>
          <Tab label="Search" value="Search" />
          <Tab label="All Songs" value="All Songs" />
        </Tabs>
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>
        {tab === 'Search' ? (
          <FullSearch onOpen={handleOpen} onClose={handleClose} currentEntity={currentEntity} />
        ) : null}
        {tab === 'All Songs' ? (
          <SearchList
            query={allQueries.type({
              types: ['song'],
              size: 100,
              sort: 'updated',
            })}
            onChange={navigateToEntity}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  ) : null

  return {
    open,
    setOpen,
    dialog,
  }
}
